export const rules = {
  data() {
    return {
      required: (v) =>
        (v !== null && v !== undefined && v !== "") ||
        "This field is required.",
      requiredNotAllowZero: (v) =>
        (v !== null && v !== undefined && v !== "" && v != "0") ||
        "This field is required.",
      number: (v) => !v || /^[1-9]\d*$/.test(v) || "Invalid format.",
      currency: (v) =>
        !v ||
        /(?=.*?\d)^(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/.test(v) ||
        "Invalid format.",
      dateTime: (v) =>
        !v ||
        /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4} (0[0-9]|1[0-2]):([0-5][0-9])$/.test(
          v
        ) ||
        "Invalid date and time format. Use MM/DD/YYYY hh:mm.",
      percent: (v) =>
        !v ||
        /(^100(\.0{1,3})?$)|(^([1-9]([0-9])?|0)(\.[0-9]{1,3})?$)/g.test(v) ||
        "Invalid format.",
      point: (v) => !v || /^[+-]?\d+(\.\d+)?$/g.test(v) || "Invalid format.",
      zipcode: (v) =>
        !v || /^\d{5}$|^\d{5}-\d{4}$/.test(v) || "Invalid format.",
      letter: (v) => !v || /^(\s*|[a-zA-Z\s])*$/.test(v) || "Invalid format.",
      name: (v) => !v || /^(\s*|[a-zA-Z\s'-])*$/.test(v) || "Invalid format.",
      email: (v) =>
        !v ||
        /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
          v
        ) ||
        "Please enter a valid email address, e.g., example@domain.com",
      phone: (v) =>
        !v ||
        /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(v) ||
        "Invalid format.",
      creditScore: (v) =>
        !v ||
        (v >= 400 && v <= 850) ||
        "Credit Score must be between 400 and 850.",
      mmddyyyy: (v) =>
        !v ||
        /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/.test(v) ||
        "Invalid format. (MM/DD/YYYY)",
      mmddyyyyhhss: (v) =>
        !v ||
        /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2} (20|21|22|23|[0-1]?\d):[0-5]?\d$/.test(
          v
        ) ||
        "Invalid format. (MM/DD/YYYY)",
      last4Ssn: (v) => /^\d{4}$/.test(v) || "Please enter exactly 4 digits.",
      ssn: (v) =>
        /^(\d{9}|\d{3}-\d{2}-\d{4})$/.test(v) ||
        "Please enter a valid SSN (123456789 or 123-45-6789).",
      routingNumber: (v) => {
        if (!/^\d{9}$/.test(v))
          return "Please enter a valid 9-digit routing number.";

        const digits = v.split("").map(Number);
        const checksum =
          3 * (digits[0] + digits[3] + digits[6]) +
          7 * (digits[1] + digits[4] + digits[7]) +
          1 * (digits[2] + digits[5] + digits[8]);

        return (
          checksum % 10 === 0 || "Invalid routing number (checksum failed)."
        );
      },
      accountNumber: (v) => {
        const cleaned = v.replace(/[\s-]/g, "");
        return (
          /^\d{6,17}$/.test(cleaned) ||
          "Please enter a valid account number (6 to 17 digits)."
        );
      },
      min6: (v) => v.length >= 6 || "Please enter at least 6 characters.",
      max50: (v) => v.length <= 50 || "Please enter than 50 characters",

      // letterRequiredRules: [
      //   (v) => !!v || "This field is required.",
      //   (v) =>
      //     (v || "").length <= 50 || "Input must be less than 50 characters",
      //   (v) => /^[a-zA-Z\s]*$/.test(v) || "Invalid format.",
      // ],
      // numberRules: [(v) =>
      //   !v
      //   || /^(\s*|\d+)$/.test(v)
      //   || "Invalid format."
      // ],
      // numberRequiredRules: [
      //   (v) => !!v || "This field is required.",
      //   (v) => /^(\d+)$/.test(v) || "Invalid format.",
      // ],
      // currencyRules: [
      //   (v) =>
      //     !v
      //     || /(?=.*?\d)^(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/.test(v)
      //     || "Invalid format.",
      // ],
      // currencyRequiredRules: [
      //   (v) => !!v || "This field is required.",
      //   (v) =>
      //   /(?=.*?\d)^(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/.test(v) ||
      //     "Invalid format.",
      // ],
      // emailRules: [
      //   (v) =>
      //     (v || "").length <= 100 || "Input must be less than 100 characters",
      //   (v) =>
      //     !v
      //     || /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(v)
      //     || "Invalid format.",
      // ],
      // emailRequiredRules: [
      //   (v) => !!v || "This field is required.",
      //   (v) =>
      //     (v || "").length <= 100 || "Input must be less than 100 characters",
      //   (v) =>
      //     /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
      //       v
      //     ) || "Invalid format.",
      // ],
      // phoneNumberRules: [
      //   (v) =>
      //     !v
      //     || /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(v)
      //     || "Invalid format.",
      // ],
      // phoneNumberRequiredRules: [
      //   (v) => !!v || "This field is required.",
      //   (v) =>
      //     /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(v) ||
      //     "Invalid format.",
      // ],
      // creditScoreRules: [
      //   (v) => !!v || "This field is required.",
      //   (v) =>
      //     !v
      //     || (v >= 400 && v <= 850)
      //     || "Out of range. (Must be between 400 and 850)",
      //   (v) => /^(\d+)$/.test(v) || "Invalid format.",
      // ],
      // creditScoreRequiredRules: [
      //   (v) => !!v || "This field is required.",
      //   (v) =>
      //     (v >= 400 && v <= 850) ||
      //     "Out of range. (Must be between 400 and 850)",
      //   (v) => /^(\d+)$/.test(v) || "Invalid format.",
      // ],
      // percentageRules: [
      //   (v) =>
      //     !v
      //     || /(^100(\.0{1,3})?$)|(^([1-9]([0-9])?|0)(\.[0-9]{1,3})?$)/g.test(v)
      //     || "Out of range. (Must be between 0 and 100)",
      // ],
      // percentageRequiredRules: [
      //   (v) => !!v || "This field is required.",
      //   (v) =>
      //     /(^100(\.0{1,3})?$)|(^([1-9]([0-9])?|0)(\.[0-9]{1,3})?$)/g.test(v)
      //     || "Out of range. (Must be between 0 and 100)",
      // ],
    };
  },
};

export const convert = {
  methods: {
    toErrorMessage(error) {
      return (
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      );
    },
    deepCopy(data) {
      return JSON.parse(JSON.stringify(data));
    },
    getPositiveNegativeColor(val) {
      try {
        if (parseFloat(val) > 0) {
          return "success--text";
        } else if (parseFloat(val) < 0) {
          return "error--text";
        } else {
          return "";
        }
      } catch {
        return "";
      }
    },
    toParseInt(val) {
      return val === undefined || val === null
        ? null
        : parseInt(val.toString());
    },
    toParseFloat(val) {
      return val === undefined || val === null
        ? null
        : parseFloat(val.toString().replaceAll(",", "").replaceAll("$", ""));
    },
    toString(val) {
      return val === undefined || val === null ? val : val.toString();
    },
    toOriginTypeFileData(fileData) {
      if (!fileData) {
        return fileData;
      }
      let clonedFileData = JSON.parse(JSON.stringify(fileData)); // Deep clone
      clonedFileData.fileCreditScore = this.toParseInt(
        clonedFileData.fileCreditScore
      );
      clonedFileData.estimatedCreditScore = this.toParseInt(
        clonedFileData.estimatedCreditScore
      );

      if (clonedFileData.transmittal) {
        clonedFileData.transmittal.repCreditScore = this.toParseInt(
          clonedFileData.transmittal.repCreditScore
        );
      }

      if (clonedFileData.subProp) {
        clonedFileData.subProp.appraisedValue = this.toParseFloat(
          clonedFileData.subProp.appraisedValue
        );
      }

      if (clonedFileData.loan) {
        clonedFileData.loan.baseLoan = this.toParseFloat(
          clonedFileData.loan.baseLoan
        );
        clonedFileData.loan.intRate = this.toParseFloat(
          clonedFileData.loan.intRate
        );
        clonedFileData.loan.ltv = this.toParseFloat(clonedFileData.loan.ltv);
        clonedFileData.loan.cltv = this.toParseFloat(clonedFileData.loan.cltv);
        clonedFileData.loan.purPrice = this.toParseFloat(
          clonedFileData.loan.purPrice
        );
        clonedFileData.loan.dti = this.toParseFloat(clonedFileData.loan.dti);

        if (clonedFileData.loan.refiPurpAu == null) {
          clonedFileData.loan.refiPurpAu = 0;
        }

        if (clonedFileData.loan.refiTypeFha == null) {
          clonedFileData.loan.refiTypeFha = 0;
        }

        if (clonedFileData.loan.refiTypeVa == null) {
          clonedFileData.loan.refiTypeVa = 0;
        }

        if (clonedFileData.loan.closingCosts) {
          for (let i = 0; i < clonedFileData.loan.closingCosts.length; i++) {
            clonedFileData.loan.closingCosts[i].borrowerAmount =
              this.toParseFloat(
                clonedFileData.loan.closingCosts[i].borrowerAmount
              );
            clonedFileData.loan.closingCosts[i].points = this.toParseFloat(
              clonedFileData.loan.closingCosts[i].points
            );
          }
        }

        if (clonedFileData.customFields) {
          clonedFileData.customFields.field04 = this.toString(
            clonedFileData.customFields.field04
          );
        }
      }

      if (clonedFileData.relatedLoans) {
        clonedFileData.relatedLoans.forEach((loan) => {
          loan.balanceAtClosing = this.toParseFloat(loan.balanceAtClosing);
        });
      }

      if (clonedFileData.pricingOptions) {
        // TODO...
      } else {
        clonedFileData.pricingOptions = null;
      }

      return clonedFileData;
    },
  },
};

export const checker = {
  methods: {
    checkNumber(x) {
      // check if the passed value is a number
      if (
        (typeof x == "number" ||
          typeof x == "string" ||
          typeof x == "object") &&
        !isNaN(x)
      ) {
        // check if it is integer
        if (x == null || x == undefined || x.length === 0) {
          return false;
        } else if (Number.isInteger(x)) {
          return true;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    toFloat(currency) {
      return this.isNullOrEmpty(currency)
        ? 0
        : parseFloat(currency.toString().replace(/[^0-9.-]+/g, ""));
    },
    isNullOrEmpty(val) {
      return val === undefined || val === null || val === "";
    },
    validateEmail(email) {
      return /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        email
      );
    },
  },
};
